import React from 'react'
import { useReduxSelector } from '../redux/hooks';

export default function OnlineIndicator(props: { Uid: string }) {
    const staffOnline = useReduxSelector(s => s.chat.usersOnline);
    const user = staffOnline?.find(s => s.UId === props.Uid);
    if (!user)
        return (<span className='offline k-icon k-i-close-outline' title={`offline`}></span>)


    return (
        <span className='online k-icon k-i-check-circle' title={`online`}></span>
    )
}
